import React, {useEffect, useState} from 'react';
import './scss/error-view.scss';
import {Form} from 'react-bootstrap';
import SelectBlockchainProp from './properties/select-blockchain';
import Api from '../services/api';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function SelectBlockchain({
  onChange, onLoaded, onLoading, setStatusMessage, balor
}: SelectBlockchainProp): React.ReactElement {
  const initActiveChain : string[] = [];
  const [activeChainList, setActiveChainList] = useState(initActiveChain);
  const [selectedChain, setSelectedChain] = useState('');

  const getActiveBlockchains = () => {
    onLoading();

    Api.getActiveBlockchains(balor).then((result) => {
      const activeChains:string[] = [];
      Object.entries(result).forEach((value) => {
        activeChains.push(value[0]);
      });
      setActiveChainList(activeChains);
      // Get deposit for first entry
      if (activeChains.length > 0) {
        setSelectedChain(activeChains[0]);
        onChange(activeChains[0]);
      }
      onLoaded();
    }).catch((error) => {
      console.error(error.message);
      setStatusMessage(error.message, StatusMessageTypeEnum.error);
      onLoaded();
    });
  };

  useEffect(() => {
    if (activeChainList?.length === 0) {
      getActiveBlockchains();
    }
  }, []);

  return (
    <Form.Select
      aria-label="Select blockchain"
      value={selectedChain}
      className="text-capitalize"
      style={{cursor:"pointer"}}
      onChange={(e) => { setSelectedChain(e.target.value); onChange(e.target.value); }}
    >
      {activeChainList.map((chain) => <option key={chain} className="w-100" value={chain}>{chain}</option>)}
    </Form.Select>
  );
}

export default SelectBlockchain;
